export default function ({ redirect, app }) {
  if (app.$utils.isB2B) {
    return Promise.resolve()
  }
  return redirect(app.localePath('account'))
}
